import ManaSparkParticle from "../../../../physics/magic/ManaSparkParticle"
import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type ManaSparkNodeOptions = {} & SimpleManaNodeOptions

export default class ManaSparkNode extends SimpleManaNode {

	static nodeType = 'ManaSparkNode'
	static nodeName = "Mana spark node"
	static nodeDesc = "Spawns a mana spark"
	static nodeIcon = '✨'
	static category = NodeCategories.Element

	async act(particle: ManaParticle) {

		const physicsWorld = this.world?.physicsWorld

		if (physicsWorld) {
			const manaSpark = new ManaSparkParticle({
				world: physicsWorld,

				x: particle.target.position.x,
				y: particle.target.position.y,

				amp: this.getAmp(particle)
			})

			physicsWorld.add(manaSpark)
			particle.setTarget(manaSpark)

			return true;
		}
		return false
	}

}